import React from "react";
import { observer } from "mobx-react-lite";
import { SelectorButton, SelectorButtonContentFilled } from "../SelectorButton";
import { getIconForElement } from "../../../../helper/mapElementIconHelper";
export const ActionMapViewerSelectorButtonFromElement = observer(({
  element,
  elementId,
  selectedMapElements,
  selectElement,
  children
}) => {
  const elementOnMapData = selectedMapElements.elements.find(element => element.id === elementId);
  if (!elementOnMapData) return null; // Don't use elementOnMapData.icon because it might be wrong for AreaTriggerModel / ViewAreaTriggerModel

  const icon = getIconForElement(element);
  const image = elementOnMapData.image;
  const text = elementOnMapData.label;
  return /*#__PURE__*/React.createElement(SelectorButton, {
    onClick: () => {
      selectElement(elementId);
    }
  }, /*#__PURE__*/React.createElement(SelectorButtonContentFilled, {
    icon: icon,
    image: image,
    text: text
  }));
});